var React = require('react');

function HamburgerToggle (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 14.6667C0 15.403 0.596954 16 1.33333 16H22.6667C23.403 16 24 15.403 24 14.6667C24 13.9303 23.403 13.3333 22.6667 13.3333H1.33333C0.596954 13.3333 0 13.9303 0 14.6667ZM0 8C0 8.73638 0.596954 9.33333 1.33333 9.33333H22.6667C23.403 9.33333 24 8.73638 24 8C24 7.26362 23.403 6.66667 22.6667 6.66667H1.33333C0.596954 6.66667 0 7.26362 0 8ZM1.33333 0C0.596954 0 0 0.596954 0 1.33333C0 2.06971 0.596954 2.66667 1.33333 2.66667H22.6667C23.403 2.66667 24 2.06971 24 1.33333C24 0.596954 23.403 0 22.6667 0H1.33333Z"}));
}

HamburgerToggle.defaultProps = {"className":"fill-current text-black dark:text-white","width":"24","height":"16","viewBox":"0 0 24 16"};

module.exports = HamburgerToggle;

HamburgerToggle.default = HamburgerToggle;
